<template lang="pug">
validation-observer(ref="obs" v-slot="{ invalid, handleSubmit }")
  v-form(ref="form")
    validation-provider(
      rules="required"
      name="Логин"
      vid="name"
      v-slot="{ errors }"
    )
      v-text-field(
        v-model.trim="student.name"
        name="name"
        label="Логин"
        :error-messages="errors"
        filled
        rounded
      )
    validation-provider(
      rules="required|email"
      name="Почта"
      vid="email"
      v-slot="{ errors }"
    )
      v-text-field(
        v-model.trim="student.email"
        name="email"
        label="Почта"
        :error-messages="errors"
        filled
        rounded
      )
    validation-provider(
      rules="required|min:6"
      vid="password"
      name="Пароль"
      v-slot="{ errors }"
    )
      v-text-field(
        v-model="student.password"
        type="password"
        label="Пароль"
        :error-messages="errors"
        filled
        rounded
      )
    validation-provider(
      rules="required|confirmed:password"
      name="Повторите пароль"
      v-slot="{ errors }"
    )
      v-text-field(
        v-model="student.password_confirmation"
        type="password"
        label="Повторите пароль"
        :error-messages="errors"
        filled
        rounded
      )
    //- server-data(
    //-   :method="$api.system.getTimezoneList"
    //-   v-slot="{ selectProps }"
    //- )
    //-   validation-provider(
    //-     rules="required"
    //-     name="Часовой пояс"
    //-     vid="settings_time_zone_id"
    //-     v-slot="{ errors }"
    //-   )
    //-     v-select(
    //-       v-model="student.settings_time_zone_id"
    //-       v-bind="selectProps"
    //-       name="settings_time_zone_id"
    //-       :item-text="(v) => `${v.title} ${v.zone}`"
    //-       :error-messages="errors"
    //-       label="Часовой пояс"
    //-       filled
    //-       rounded
    //-     )
      //- v-col(cols="12" md="6")
      //-   validation-provider(
      //-     rules="required"
      //-     vid="information_birthday_at"
      //-     name="Дата рождения"
      //-     v-slot="{ errors }"
      //-   )
      //-     sdo-datetime-field.fill-width(
      //-       v-model="student.information_birthday_at"
      //-       label-date="Дата рождения"
      //-       only-date
      //-       :error-messages="errors"
      //-       filled
      //-       rounded
      //-     )
    validation-provider(
      rules="required"
      vid="information_surname"
      name="Фамилия"
      v-slot="{ errors }"
    )
      v-text-field(
        v-model.trim="student.information_surname"
        label="Фамилия"
        :error-messages="errors"
        filled
        rounded
      )
    validation-provider(
      rules="required"
      vid="first_name"
      name="Имя"
      v-slot="{ errors }"
    )
      v-text-field(
        v-model.trim="student.information_first_name"
        label="Имя"
        :error-messages="errors"
        filled
        rounded
      )
    validation-provider(
      vid="information_patronymic"
      name="Отчество"
      v-slot="{ errors }"
    )
      v-text-field(
        v-model.trim="student.information_patronymic"
        label="Отчество"
        :error-messages="errors"
        filled
        rounded
      )
    v-row
      v-btn(
        color="success"
        class="ml-2 px-5 text-uppercase"
        @click="handleSubmit(signUp)"
        :disabled="invalid"
        :loading="loadingBtn"
        depressed
        block
        rounded
      ) Зарегистрироваться
</template>

<script>
export default {
  name: 'SignUpForm',
  props: {
    value: { type: Object, default: null },
    regionData: { type: Object, default: null },
    isTeacher: { type: Boolean, default: false },
  },
  data() {
    return {
      student: this.value,
      loadingBtn: false,
    };
  },
  watch: {
    student: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true,
    },
  },
  methods: {
    async signUp() {
      this.loadingBtn = true;
      // const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
      const payload = {
        ...this.student,
        settings_region_id: this.regionData.region.id,
        settings_municipality_id: this.regionData.municipality.id,
        // settings_time_zone_id: this.timezones.find((el) => timeZone === el.zone).id,
      };
      await this.$rHandler(
        this.$api.auth.registerStudent(payload),
        ({ data }) => {
          this.$emit('done', data.data);
          return data;
        },
        () => {},
        this.$refs.obs,
      );
      this.loadingBtn = false;
    },
  },
};
</script>
